export default "__VITE_ASSET__C$MY7QHp__"